module.exports = __webpack_public_path__ + "img/ts_2007.826fc69d.jpg";